import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from './store/reducers';
import Auth from './pages/Auth';
import Layout from './components/Layout';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/Dashboard';
import Numerisation from './pages/Numerisation';
import Decisions from './pages/Decisions';
import DecisionDetail from './pages/DecisionDetail';
import Recherche from './pages/Recherche';
import AdminDashboard from './pages/AdminDashboard';
import AdminNumerisation from './pages/AdminNumerisation';
import AdminDecisions from './pages/AdminDecisions';
import AdminRoles from './pages/AdminRoles';
import AdminReassignation from './pages/AdminReassignation';
import Users from './pages/Users';
import Historique from './pages/Historique';
import Profile from './pages/Profile';
import UserDetail from './pages/UserDetail';
import './App.css';

const PrivateRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  return isAuthenticated ? children : <Navigate to="/connexion" replace />;
};

const AdminRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/connexion" replace />;
  }

  const roles = (user?.role || []).map((r: any) => r.name);
  const isAdmin = roles.includes('admin') || roles.includes('superadmin');

  return isAdmin ? children : <Navigate to="/espace-cndj" replace />;
};

const RootRedirect: React.FC = () => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
  if (isAuthenticated && user) {
    const roles = (user.role || []).map((r: any) => r.name);
    const isAdmin = roles.includes('admin') || roles.includes('superadmin');
    return <Navigate to={isAdmin ? '/espace-admin' : '/espace-cndj'} replace />;
  }
  return <Navigate to="/connexion" replace />;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Redirect root based on auth state */}
        <Route path="/" element={<RootRedirect />} />

        {/* Auth - login only */}
        <Route path="/connexion" element={<Auth />} />

        {/* Espace Agent (CNDJ) */}
        <Route path="/espace-cndj" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="numerisation" element={<Numerisation />} />
          <Route path="decisions" element={<Decisions />} />
          <Route path="decisions/:id" element={<DecisionDetail />} />
          <Route path="recherche" element={<Recherche />} />
          <Route path="profile" element={<Profile />} />
        </Route>

        {/* Espace Admin */}
        <Route path="/espace-admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
          <Route index element={<AdminDashboard />} />
          <Route path="utilisateurs" element={<Users />} />
          <Route path="utilisateurs/:id" element={<UserDetail />} />
          <Route path="roles" element={<AdminRoles />} />
          <Route path="reassignation" element={<AdminReassignation />} />
          <Route path="numerisation" element={<AdminNumerisation />} />
          <Route path="decisions" element={<AdminDecisions />} />
          <Route path="decisions/:id" element={<DecisionDetail />} />
          <Route path="historique" element={<Historique />} />
          <Route path="profile" element={<Profile />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/connexion" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
